import { createFileRoute } from '@tanstack/react-router'

import { PropensityAccuracyScreen } from './-components/propensity-accuracy-screen.tsx'

export const Route = createFileRoute('/collections/propensity-accuracy')({
  component: PropensityAccuracyScreen
})
